import { render, staticRenderFns } from "./VIPRenew.vue?vue&type=template&id=11ae26a8&scoped=true&"
import script from "./VIPRenew.vue?vue&type=script&lang=js&"
export * from "./VIPRenew.vue?vue&type=script&lang=js&"
import style0 from "./VIPRenew.vue?vue&type=style&index=0&id=11ae26a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ae26a8",
  null
  
)

export default component.exports